var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rounded-lg shadow-none"
  }, [_vm.isSelectAll || _vm.selectedItem.length ? _c('div', {
    staticClass: "d-flex align-items-end justify-content-start mb-4 px-4",
    staticStyle: {
      "gap": "10px"
    }
  }, [_vm.roleID !== 5 ? _c('Button', {
    staticClass: "mr-2 bg-red-500 text-white",
    attrs: {
      "disabled": _vm.isLoadingUnPublish,
      "variant": "default",
      "size": "sm",
      "color": "red"
    },
    on: {
      "click": _vm.onSubmitUnPublishSelected
    }
  }, [_vm.isLoadingUnPublish ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('em', {
    staticClass: "fa fa-eye-slash"
  }), _vm._v(" UnPublished ")], 1) : _vm._e(), _vm.roleID !== 5 ? _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.selectedItem.length) + " selected item")]) : _vm._e()], 1) : _vm._e(), _c('Table', {
    ref: "tableList",
    staticClass: "shadow-none",
    attrs: {
      "headers": _vm.headers,
      "data": _vm.books,
      "withSelectable": _vm.roleID !== 5 ? true : false,
      "row-key": ['name', 'id', 'content_type', 'is_active', 'item_status', 'page_count', 'file_size', 'vendor'],
      "current-page": _vm.currentPage,
      "selectedItem": _vm.selectedItem,
      "isLoading": _vm.isLoading,
      "per-page": _vm.perPage
    },
    on: {
      "row-selected": _vm.onRowSelected,
      "toggle-row": _vm.toggleRowSelection,
      "update:selectedItem": function ($event) {
        _vm.selectedItem = $event;
      },
      "update:selected-item": function ($event) {
        _vm.selectedItem = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "header-create",
      fn: function (_ref) {
        var column = _ref.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "header-modified",
      fn: function (_ref2) {
        var column = _ref2.column;
        return [_c('div', {
          staticClass: "flex items-center gap-1"
        }, [_vm._v(" " + _vm._s(column.label) + " "), _c('button', {
          staticClass: "text-xs text-gray-500",
          on: {
            "click": function ($event) {
              return _vm.sortBy(column.key);
            }
          }
        }, [_c('span', {
          attrs: {
            "href": "#"
          }
        }, [_c('svg', {
          staticClass: "w-3 h-3 ms-1.5",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "d": "M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z"
          }
        })])])])])];
      }
    }, {
      key: "header-no",
      fn: function (_ref3) {
        var column = _ref3.column;
        return [_c('div', {
          staticClass: "flex justify-start"
        }, [_vm.roleID !== 5 ? _c('t-checkbox', {
          staticClass: "mr-2 ml-2",
          on: {
            "input": _vm.onSelectAllRows
          },
          model: {
            value: _vm.isSelectAll,
            callback: function ($$v) {
              _vm.isSelectAll = $$v;
            },
            expression: "isSelectAll"
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(column.label) + " ")], 1)];
      }
    }, {
      key: "name",
      fn: function (_ref4) {
        var row = _ref4.row;
        return [row.item_status === 'uploading' ? _c('div', {
          staticClass: "text-left flex justify-start items-center text-gray-600"
        }, [_c('span', [_vm._v(_vm._s(row.name))])]) : row.item_type === 'book' ? _c('router-link', {
          staticClass: "text-center text-blue-700 hover:no-underline hover:text-blue-700",
          attrs: {
            "to": {
              name: _vm.ManageFormEbookPath.name,
              params: {
                id: row.id.toString()
              }
            }
          }
        }, [_vm._v(" " + _vm._s(row.name) + " ")]) : _c('span', {
          staticClass: "text-center text-blue-700 hover:no-underline hover:text-blue-700",
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.actionEdit(row);
            }
          }
        }, [_vm._v(" " + _vm._s(row.name) + " ")])];
      }
    }, {
      key: "id",
      fn: function (_ref5) {
        var value = _ref5.value;
        return [_c('span', {
          staticClass: "uppercase text-center"
        }, [_c('button', {
          staticClass: "relative block border text-center p-1.5",
          staticStyle: {
            "border-radius": "7px"
          },
          attrs: {
            "size": "sm",
            "variant": "outline"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.copyTextToClipboard(value);
            }
          }
        }, [_c('span', {
          staticClass: "flex justify-center items-center top-0 text-center text-xs"
        }, [_vm._v(" " + _vm._s(value) + " "), _c('svg', {
          staticClass: "w-4 h-4 text-gray-400 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M7 9v6a4 4 0 0 0 4 4h4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1v2Z",
            "clip-rule": "evenodd"
          }
        }), _c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M13 3.054V7H9.2a2 2 0 0 1 .281-.432l2.46-2.87A2 2 0 0 1 13 3.054ZM15 3v4a2 2 0 0 1-2 2H9v6a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-3Z",
            "clip-rule": "evenodd"
          }
        })])])])])];
      }
    }, {
      key: "content_type",
      fn: function (_ref6) {
        var row = _ref6.row;
        return [row.item_status !== 'ready for upload' ? _c('span', {
          staticClass: "uppercase"
        }, [_vm._v(" " + _vm._s(row.content_type) + " ")]) : _c('span', [_vm._v(" - ")])];
      }
    }, {
      key: "is_active",
      fn: function (_ref7) {
        var value = _ref7.value;
        return [_c('span', {
          class: [{
            'bg-green-100 text-green-800': value,
            'bg-gray-200 text-gray-800': !value
          }, 'text-left rounded-lg text-xs p-1 px-2 ml-2']
        }, [_vm._v(" " + _vm._s(_vm.formatBoolean(value)) + " ")])];
      }
    }, {
      key: "item_status",
      fn: function (_ref8) {
        var row = _ref8.row;
        return [_c('div', {
          staticClass: "w-36 block text-left px-2"
        }, [row.item_status === 'uploading' ? _c('span', {
          staticClass: "flex w-max",
          class: _vm.getStatusClass(row.item_status)
        }, [_c('svg', {
          staticClass: "w-4 h-4 mr-1 text-orange-800 dark:text-white",
          attrs: {
            "aria-hidden": "true",
            "xmlns": "http://www.w3.org/2000/svg",
            "width": "24",
            "height": "24",
            "fill": "currentColor",
            "viewBox": "0 0 24 24"
          }
        }, [_c('path', {
          attrs: {
            "fill-rule": "evenodd",
            "d": "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z",
            "clip-rule": "evenodd"
          }
        })]), _vm._v(" " + _vm._s(row.item_status) + " ")]) : _c('span', {
          class: _vm.getStatusClass(row.item_status)
        }, [_vm._v(" " + _vm._s(row.item_status) + " ")])])];
      }
    }, {
      key: "file_size",
      fn: function (_ref9) {
        var value = _ref9.value;
        return [_c('span', {
          staticClass: "w-16 block text-left"
        }, [_vm._v(" " + _vm._s(_vm.convertMegaBite(value)) + " ")])];
      }
    }, {
      key: "actions",
      fn: function (_ref10) {
        var row = _ref10.row;
        return [_c('div', {
          on: {
            "click": function ($event) {
              $event.stopPropagation();
            }
          }
        }, [_c('t-dropdown', {
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function (_ref11) {
              var mousedownHandler = _ref11.mousedownHandler,
                focusHandler = _ref11.focusHandler,
                blurHandler = _ref11.blurHandler,
                keydownHandler = _ref11.keydownHandler,
                isShown = _ref11.isShown;
              return _c('div', {
                on: {
                  "focus": function ($event) {
                    $event.stopPropagation();
                    return focusHandler.apply(null, arguments);
                  },
                  "blur": function ($event) {
                    $event.stopPropagation();
                    return blurHandler.apply(null, arguments);
                  },
                  "keydown": function ($event) {
                    $event.stopPropagation();
                    return keydownHandler.apply(null, arguments);
                  },
                  "click": function ($event) {
                    $event.stopPropagation();
                    return mousedownHandler.apply(null, arguments);
                  }
                }
              }, [_c('button', {
                staticClass: "cursor-pointer focus:outline-none",
                class: {
                  ' text-gray-500 ': isShown,
                  'opacity-50': row.item_status === 'uploading'
                },
                attrs: {
                  "id": "user-menu",
                  "disabled": row.item_status === 'uploading',
                  "aria-label": "User menu",
                  "aria-haspopup": "true"
                },
                on: {
                  "focus": function ($event) {
                    $event.stopPropagation();
                    return focusHandler.apply(null, arguments);
                  },
                  "blur": function ($event) {
                    $event.stopPropagation();
                    return blurHandler.apply(null, arguments);
                  },
                  "keydown": function ($event) {
                    $event.stopPropagation();
                    return keydownHandler.apply(null, arguments);
                  },
                  "click": function ($event) {
                    $event.stopPropagation();
                    return mousedownHandler.apply(null, arguments);
                  }
                }
              }, [_c('i', {
                staticClass: "fa-solid fa-ellipsis"
              })])]);
            }
          }, {
            key: "default",
            fn: function (_ref12) {
              var _row$item_status, _row$item_status2;
              var hide = _ref12.hide,
                blurHandler = _ref12.blurHandler;
              return _c('div', {}, [_c('button', {
                staticClass: "block text-left w-full px-4 py-2 text-sm le ading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                class: {
                  hidden: _vm.roleID === 5,
                  'opacity-50 pointer-events-none': ['ready for consume', 'ready for upload', 'failed to upload'].includes((_row$item_status = row.item_status) === null || _row$item_status === void 0 ? void 0 : _row$item_status.trim())
                },
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  },
                  "blur": blurHandler
                }
              }, [_vm.roleID !== 5 ? _c('div', {
                staticClass: "flex items-center",
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.actionUpdateStatus(row, 'publish', _vm.status.Published);
                  }
                }
              }, [_c('svg', {
                staticClass: "w-6 h-6 text-gray-500 dark:text-white",
                attrs: {
                  "aria-hidden": "true",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "width": "24",
                  "height": "24",
                  "fill": "none",
                  "viewBox": "0 0 24 24"
                }
              }, [_c('path', {
                attrs: {
                  "stroke": "currentColor",
                  "stroke-width": "2",
                  "d": "M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
                }
              }), _c('path', {
                attrs: {
                  "stroke": "currentColor",
                  "stroke-width": "2",
                  "d": "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
              })]), _c('span', {
                staticClass: "flex items-center ml-2"
              }, [_vm._v(" Published ")])]) : _vm._e()]), _c('button', {
                staticClass: "block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                class: {
                  hidden: _vm.roleID === 5,
                  'opacity-50 pointer-events-none': ['not for consume', 'need approval', 'ready for upload', 'failed to upload'].includes((_row$item_status2 = row.item_status) === null || _row$item_status2 === void 0 ? void 0 : _row$item_status2.trim())
                },
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  },
                  "blur": blurHandler
                }
              }, [_vm.roleID !== 5 ? _c('div', {
                staticClass: "flex items-center",
                attrs: {
                  "variant": "danger"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return _vm.actionUpdateStatus(row, 'unpublish', _vm.status.Unpublished);
                  }
                }
              }, [_c('svg', {
                staticClass: "w-6 h-6 text-gray-500 dark:text-white",
                attrs: {
                  "aria-hidden": "true",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "width": "24",
                  "height": "24",
                  "fill": "none",
                  "viewBox": "0 0 24 24"
                }
              }, [_c('path', {
                attrs: {
                  "stroke": "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  "d": "M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                }
              })]), _c('span', {
                staticClass: "flex items-center ml-2"
              }, [_vm._v(" UnPublished ")])]) : _vm._e()]), _c('button', {
                staticClass: "block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100",
                attrs: {
                  "role": "menuitem"
                },
                on: {
                  "click": function ($event) {
                    $event.stopPropagation();
                    return hide.apply(null, arguments);
                  },
                  "blur": blurHandler
                }
              }, [_c('div', {
                staticClass: "flex items-center",
                attrs: {
                  "variant": "default"
                },
                on: {
                  "click": function ($event) {
                    return _vm.actionEdit(row);
                  }
                }
              }, [_c('svg', {
                staticClass: "w-6 h-6 text-gray-500 dark:text-white",
                attrs: {
                  "aria-hidden": "true",
                  "xmlns": "http://www.w3.org/2000/svg",
                  "width": "24",
                  "height": "24",
                  "fill": "none",
                  "viewBox": "0 0 24 24"
                }
              }, [_c('path', {
                attrs: {
                  "stroke": "currentColor",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  "d": "m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z"
                }
              })]), _c('span', {
                staticClass: "flex items-center ml-2"
              }, [_vm._v(" Edit Items ")])])])]);
            }
          }], null, true)
        })], 1)];
      }
    }])
  }), _c('t-modal', {
    ref: "confirmationModal"
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center"
  }, [_c('label', {
    staticClass: "text-center font-semibold"
  }, [_vm._v("Are You Sure?")]), _c('p', {
    staticClass: "text-left text-gray-500"
  }, [_vm._v("This action is quite dangerous, do you still want to continue?")])]), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-blue-500 text-white p-1 px-2 rounded-lg mr-1 text-sm",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _c('button', {
    staticClass: "bg-white border text-gray-500 p-1 px-2 rounded-lg ml-1 text-sm",
    on: {
      "click": _vm.confirmBulkUnPublish
    }
  }, [_vm._v("Yes")])])]), _c('t-modal', {
    ref: "modalUpdateStatus"
  }, [_c('div', {
    staticClass: "text-sm flex-col"
  }, [this.titleModalUpdateStatus === 'unpublish' ? _c('div', {
    staticClass: "text-center"
  }, [_c('label', {
    staticClass: "text-center text-lg font-semibold"
  }, [_vm._v(" Unpublished Content ")]), _c('p', [_vm._v("Once unpublished, it will no longer appear on the homepage, PDP, or in user search results.")])]) : _c('div', [_c('label', {
    staticClass: "text-left font-semibold"
  }, [_vm._v(" Are you sure want to " + _vm._s(this.titleModalUpdateStatus) + " ? ")]), _c('div', [_c('p', {
    staticClass: "text-left text-gray-500"
  }, [_vm._v(_vm._s(_vm.nameModalUpdateStatus) + " " + _vm._s(this.statusModalUpdate) + " ")])])])]), this.titleModalUpdateStatus === 'unpublish' ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('Button', {
    staticClass: "mr-3",
    attrs: {
      "disabled": _vm.isLoadingUnPublish,
      "variant": "default",
      "size": "xs"
    },
    on: {
      "click": _vm.confirmUpdateStatus
    }
  }, [_vm._v(" Unpublished ")]), _c('Button', {
    attrs: {
      "size": "xs",
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1) : _c('div', {
    staticClass: "flex justify-center"
  }, [_c('Button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "default",
      "size": "xs"
    },
    on: {
      "click": _vm.confirmUpdateStatus
    }
  }, [_vm._v(" Published ")]), _c('Button', {
    attrs: {
      "size": "xs",
      "variant": "outlined",
      "color": "alternative"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }